import {TabState, TabStateDefaults} from 'Navigation';

export default class VisualizationState extends TabState {
  defaults(): TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Visualization',
      closeable: false,
      preferenceKey: 'visualization',
    };
  }
}
